export default "__VITE_ASSET__21807d83__"